/**
 * 공통 method, util
 */
export const exp = null;
export const REGEX_KOREAN = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
export const REGEX_SPECIAL_ID = /[`.,'"~+=<>!@#$%^&()*|\\\'\"\{\}\[\];:\/?]/;
export const REGEX_WRONG_SPECIAL = /[<>'&"()#]/;
export const REGEX_NUMBER = /[^0-9]/g;
export const ID_REGEX = /^([a-z|A-Z|0-9|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\₩]+)$/;
export const PWD_REGEX = /^.*(?=^.{10,50}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=]).*$/;
export const NAME_REGEX = /^([a-z|A-Z|0-9|가-힣|\.]+)$/;

/**
 * html 특수문자 변경
 * @param str
 */
export const parseHtmlEntities = (str: string) => {
  return str.replace(/&#([0-9]{1,3});/gi, function (match, numStr) {
    const num = parseInt(numStr, 10); // read num as normal number
    return String.fromCharCode(num);
  });
};

/**
 * 디바운스 글로벌 적용
 * @param callback
 * @param delay
 */
export const debounce = (callback: any, delay: number) => {
  let timer: any;
  return (...args: any) => {
    // 실행한 함수(setTimeout())를 취소
    clearTimeout(timer);
    // delay가 지나면 callback 함수를 실행
    timer = setTimeout(() => callback(...args), delay);
  };
};
